import axios from './api';
import { getUrl } from './utils';
const endPoint = getUrl('api') + '/api/v2/nonconformity';

export const getNonConformity = async (pid) => {
  return axios.get(`${endPoint}/${pid}`);
};

export const createNonConformity = async (data, batch) => {
  return axios.post(`${endPoint}/concretebatch/${batch}`, data);
};

export const updateNonConformity = async (pid, data) => {
  return axios.put(`${endPoint}/${pid}`, data);
};
